<div class="wrap-hero">
  <app-header></app-header>
  <!-- <app-hero></app-hero> -->
</div>
<div class="">
  <app-main-gallery></app-main-gallery>
</div>
<app-historia></app-historia>
<app-schedule-restaurant></app-schedule-restaurant>

<app-food-gallery></app-food-gallery>
<app-reviews></app-reviews>
<!-- <app-featured-insurance> </app-featured-insurance>
<app-action-call></app-action-call> -->


<app-mapa></app-mapa>

<app-footer></app-footer>
